// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";

import Layout from "./components/Layout";
import router from "./router";
import utils from "./utils/util";
import filters from "./filters/index";
import store from "./store/index.js";
import { InterfaceService } from "@/services/api";
import { BASE_CONFIG } from "@/config/config.js";

// element ui component
import ElementUi from "@/utils/elementUi.js";
import "@/styles/element-variables.scss";

import i18n from "@/lang/index";
import Loading from "@/components/loading/loading.js";
Vue.use(Loading);

// 引入插件
import ImageView from "@/plugins/imageView/imageView"
Vue.use(ImageView);

Vue.config.productionTip = false;
Vue.use(utils);
Vue.use(filters);
Vue.use(ElementUi);
Vue.prototype.$http = InterfaceService;
Vue.prototype.$baseStaticUrl = BASE_CONFIG.STATICS_CDN_URL;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  template: "<Layout/>",
  components: {
    Layout
  },
  mounted() {},
  methods: {}
});



// WEBPACK FOOTER //
// ./src/main.js